module.exports = __webpack_public_path__ + "static/img/3_1_7_1.3c288cdf.jpg";